import { AuthorizationResult } from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { createInterpolatedTranslationKey, InterpolatedTranslationKey } from '@dreryk/react-common';
import { MessageType } from '@dreryk/react-components';

import { onlinePaymentsProviderDetailsTranslationKeys } from '../../translations';

export const messageTypes = {
   SUCCESS: MessageType.POSITIVE,
   FAILURE: MessageType.NEGATIVE,
} as const;

export const getStatusLabel = (
   onlinePaymentsAuthorizationResult: AuthorizationResult
): InterpolatedTranslationKey | string => {
   if (onlinePaymentsAuthorizationResult.status === 'SUCCESS') {
      return onlinePaymentsProviderDetailsTranslationKeys.generalInformation.integrationStatus.status.active;
   }

   return createInterpolatedTranslationKey(
      onlinePaymentsProviderDetailsTranslationKeys.generalInformation.integrationStatus.status.inactive,
      {
         errorMessage: onlinePaymentsAuthorizationResult.errorDescription,
      }
   );
};
